var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBailSecurity = function SvgBailSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.204 13.475-3.46 5.993-3.314 5.738h6.624l.982-1.702.477-.825 1.853-3.21.15-.258-.328-.568-1.819-3.15-.48-.83-.684-1.186v-.001l-.001-.001Z",
    fill: "#3F6870"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.271 8.186-.48-.83-2.984-5.165-.476-.826L12 .791l-.33.574-.477.826L8.21 7.357l-.48.83v-.003L0 21.572h24L16.271 8.184v.002ZM12 2.45l3.311 5.735.479.83h-.001l2.982 5.167H12.15l-.15-.262-2.147-3.717-.48-.83-.685-1.188L12 2.45ZM1.435 20.747l3.314-5.738 3.46-5.994h.001v.002l.686 1.188.479.83 1.818 3.148.328.568-.148.258-1.854 3.21-.476.825-.982 1.703H1.435ZM10 19.043l.477-.825L12 15.582l.33-.573h6.921l3.314 5.738H9.018L10 19.044Z",
    fill: "#3F6870"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.79 13.473v.002l-.48-.83-3.312-5.735-3.31 5.734.685 1.188.479.83 2.146 3.718.152.262h6.622l-2.982-5.166v-.003ZM12.005 20.044l-1.523 2.637-.476.826-.983 1.702H22.57l-3.312-5.738h-6.922l-.33.573Z",
    fill: "#3F6870"
  })));
};
export default SvgBailSecurity;